import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import queryString from 'query-string';

import api from 'core/utils/api';
import TestForm from './TestForm/TestForm';
import * as notify from 'components/ui/Notify/store/actions';
import Spin from 'components/ui/Spin';

class TestNewContainer extends Component {
  constructor(props) {
    super(props);
    const { propertyId } = queryString.parse(this.props.location.search);

    this.state = {
      loading: true,
      propertyId,
      initialValues: {
        placed_at: moment().toISOString(),
        test_devices: [],
      }
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { propertyId, initialValues } = this.state;

    if (!propertyId) {
      this.setState({ loading: false });
      return;
    }

    api
      .get(`/properties/${propertyId}`)
      .then((res) => {
        const { property } = res.data;
        this.setState({
          loading: false,
          initialValues: { ...initialValues, property },
        });
      });
  }

  handleSubmit(test) {
    const { dispatch, history } = this.props;

    api.post('/tests', { test })
      .then(() => {
        dispatch(notify.actions.success('Test was successfully created.'));
        history.push('/tests');
      });
  }

  render() {
    const { loading, initialValues } = this.state;

    if (loading) {
      return <Spin />;
    }

    return (
      <TestForm
        onSubmit={this.handleSubmit}
        initialValues={initialValues}
      />
    );
  }
}

export default connect()(TestNewContainer);



// WEBPACK FOOTER //
// ./src/features/test/TestNewContainer.js